// GraphQL queries and mutations for Subscriptions (proxy membership API)

export const listSubscriptionsQuery = `
  query ListSubscriptions($input: ListSubscriptionsInput!) {
    listSubscriptions(input: $input) {
      code
      subscriptionList {
        subscriptionId
        companyId
        planId
        planName
        billingCycleId
        billingCycleCode
        priceAmount
        priceCurrency
        status
        subscriptionStartsAt
        subscriptionEndsAt
        nextBillingAt
        cancelAtPeriodEnd
        createdAt
        updatedAt
      }
    }
  }
`;

export const getSubscriptionQuery = `
  query GetSubscription($input: GetSubscriptionInput!) {
    getSubscription(input: $input) {
      code
      subscription {
        subscriptionId
        companyId
        planId
        planName
        billingCycleId
        billingCycleCode
        priceAmount
        priceCurrency
        status
        subscriptionStartsAt
        subscriptionEndsAt
        nextBillingAt
        cancelAtPeriodEnd
        createdAt
        updatedAt
      }
    }
  }
`;

export const createSubscriptionMutation = `
  mutation CreateSubscription($input: CreateSubscriptionInput!) {
    createSubscription(input: $input) {
      code
      subscriptionId
    }
  }
`;

export const cancelSubscriptionMutation = `
  mutation CancelSubscription($input: CancelSubscriptionInput!) {
    cancelSubscription(input: $input) {
      code
      subscription {
        subscriptionId
        companyId
        planId
        planName
        billingCycleId
        billingCycleCode
        priceAmount
        priceCurrency
        status
        subscriptionStartsAt
        subscriptionEndsAt
        nextBillingAt
        cancelAtPeriodEnd
        createdAt
        updatedAt
      }
    }
  }
`;
